var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`position:absolute;right:${_vm.collapse?-_vm.width:0}px;top:43px;bottom:0;width:400px;background:var(--bg3);color:var(--text3);transition:all 0.8s`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }